export function showBylineDateByTopic(primaryTopic: string | undefined) {
    const topicsWithDateInByline = ['news/up-late']
    return primaryTopic && topicsWithDateInByline.includes(primaryTopic)
        ? true
        : false
}
